import loadable from '@loadable/component'
import { createRenderTarget } from '../../render-target'
import { Logger } from 'typescript-log'
import { LinkClickedEvent } from '@news-mono/web-common'
import { PlayerEvent } from '@news-mono/web-common'
import { CardEvents } from '@news-mono/web-common'
import { CollectionEvent } from '@news-mono/web-common'

// Implementing lazy loaded components is explained in README.md
export const LazyAmpEmbed = loadable(() => import('./Embed.amp'))

export const LazyRssEmbed = loadable(() => import('./Embed.rss'))

export const LazyWebEmbed = loadable(() => import('./Embed.web'))

export const LazyPreviewEmbed = loadable(() => import('./Embed.preview'))

export interface EmbedProps {
    link: string
    onEvent: (
        event: PlayerEvent | LinkClickedEvent | CardEvents | CollectionEvent,
    ) => void
    log: Logger
    adUnitPath: string
}

export const Embed = createRenderTarget<EmbedProps>('Embed', {
    amp: LazyAmpEmbed,
    web: LazyWebEmbed,
    rss: LazyRssEmbed,
    preview: LazyPreviewEmbed,
    app: LazyWebEmbed,
})
